import React from "react"

export const Footnotes = ({ classes, small, nolink, notes, footnotes }) => {
  return (
    <div
      className={`
        footnotes
        ${small ? "footnotes--small" : ""}
        ${classes ? classes : ""}
      `}
    >
      <h2 className="util__screen-reader-only">Footnotes</h2>

      {notes &&
        notes.map((item, index) => {
          return (
            <p
              dangerouslySetInnerHTML={{ __html: item }}
              key={`note-${index + 1}`}
            />
          )
        })}

      <ol>
        {footnotes.map((item, index) => {
          return (
            <li id={`footnote-${index + 1}`} key={`footnote-${index + 1}`}>
              <span dangerouslySetInnerHTML={{ __html: item }} />
              {!nolink && (
                <>
                  {" "}
                  <a
                    href={`#footnote-${index + 1}-ref`}
                    className="footnotes__ref-link"
                    aria-label="Back to content"
                  >
                    ↩
                  </a>
                </>
              )}
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export const FootnoteRef = ({ id }) => {
  return (
    <a
      href={`#footnote-${id}`}
      id={`footnote-${id}-ref`}
      className="footnote-ref"
      aria-label={`Read footnote ${id}`}
    >
      [{id}]
    </a>
  )
}
